export function TwoCoinsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_11096_11267)">
        <path
          d="M11.9533 11.9533C14.5202 11.6096 16.5 9.41101 16.5 6.75C16.5 3.8505 14.1495 1.5 11.25 1.5C8.58899 1.5 6.39037 3.47975 6.0467 6.0467M5.625 9.75L6.75 9V13.125M5.625 13.125H7.875M12 11.25C12 14.1495 9.6495 16.5 6.75 16.5C3.8505 16.5 1.5 14.1495 1.5 11.25C1.5 8.3505 3.8505 6 6.75 6C9.6495 6 12 8.3505 12 11.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11096_11267">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
